module.exports = __webpack_public_path__ + "img/10_54.ee37d7e2.png";